import { SELLER_REPORT_REVISION } from './schema';
/** Seller artifacts share the existing campaign report bucket with an isolated namespace. */
export async function sellerArtifactReference(sellerId: string, content?: unknown): Promise<string> {
  const bytes = await crypto.subtle.digest('SHA-256',new TextEncoder().encode(`${sellerId}:seller-company:${SELLER_REPORT_REVISION}:${content ? JSON.stringify(content) : ''}`));
  return `seller_${Array.from(new Uint8Array(bytes),b=>b.toString(16).padStart(2,'0')).join('').slice(0,24)}`;
}

/** Client-visible name identifies the team, company and document language. */
export function sellerReportFilename(teamName: string, sellerId: string, language: string): string {
  if (!/^[\w-]{1,36}$/.test(sellerId)) throw new Error('Invalid seller id for report download.');
  if (!/^[a-z]{2,3}(?:-[a-z0-9]{2,8})*$/i.test(language)) throw new Error('Invalid report language for download.');
  const team = teamName.trim().replace(/[<>:"/\\|?*\u0000-\u001f]/g, '').replace(/\s+/g, '_').replace(/[. ]+$/g, '') || 'Brainiacs';
  return `${team}_seller_${sellerId}_${language.toLowerCase()}.pdf`;
}
